export default {
  shared: {
    recentTransactionsTitle: "Letzte Transaktionen",
    recentTransactionsEmpty: "Noch keine Transaktionen",
    recentTransactionsHint: "Ihre letzten Aktivitäten erscheinen hier",
    loadingData: "Dashboard-Daten werden geladen...",
    errorLoad: "Fehler beim Laden der Dashboard-Daten",
    quickActions: "Schnellaktionen",
    title: "Dashboard",
    greetingWithName: "{{greeting}}, {{name}}!",
    wallet: "Wallet",
  },
  admin: {
    greetingWithName: "{{greeting}}, Staff!",
    overviewStats: "Plattform-Übersicht und Statistiken",
    viewSellers: "Verkäufer anzeigen",
    viewSellersDesc: "Verkäuferkonten verwalten",
    supportTickets: "Support-Tickets",
    supportTicketsDesc: "Support-Anfragen bearbeiten",
    manageActivities: "Aktivitäten",
    manageActivitiesDesc: "Katalog prüfen und konfigurieren",
    manageStructures: "Strukturen",
    manageStructuresDesc: "Unterkünfte, Gastgeber und Kioske",
    notificationsTitle: "Betriebswarnungen",
    notificationsViewAll: "Alle anzeigen",
    notificationsLoading: "Warnungen werden geladen...",
    notificationsError: "Warnungen konnten nicht geladen werden",
    notificationsEmpty: "Keine offenen Warnungen",
    notificationsMore:
      "{{count}} weitere — Posteingang für vollständige Liste öffnen",
    statTotalPlatformBalance: "Gesamtsaldo der Plattform",
    statTotalSellers: "Verkäufer gesamt",
    statActiveSellers: "{{count}} aktiv",
    statTotalActivities: "Aktivitäten gesamt",
    statActiveActivities: "{{count}} aktiv",
    statActivitiesBreakdown: "{{restaurants}} Restaurants · {{services}} Services",
    statTotalHouses: "Häuser gesamt",
    statActiveHouses: "{{count}} aktiv",
  },
  partner: {
    overview: "Übersicht über Ihr Geschäft",
    sellerIdMissing: "Verkäufer-Benutzer-ID nicht gefunden",
    greeting: "Hier ist eine Zusammenfassung Ihres Geschäfts",
    myActivities: "Meine Aktivitäten",
    myActivitiesDesc: "Services & Menüs verwalten",
    bookings: "Buchungen",
    bookingsDesc: "Aktuelle Reservierungen anzeigen",
    walletDesc: "Einnahmen prüfen",
    statsWalletBalance: "Wallet-Saldo",
    statsAmountOwed: "Ausstehender Betrag",
    statsBookings30d: "Buchungen (30 T.)",
    statsRevenue30d: "Umsatz (30 T.)",
    statsTransactions30d: "Transaktionen (30 T.)",
    statsTrendVsPrev: "ggü. vorigen 30 T.",
  },
  host: {
    myStructures: "Meine Strukturen",
    myStructuresDesc: "Häuser und Geräte verwalten",
    walletDesc: "Provisionen und Auszahlungen ansehen",
    overview: "Übersicht über Ihre Strukturen",
    hostIdMissing: "Gastgeber-Benutzer-ID nicht gefunden",
    greeting: "Hier ist eine Zusammenfassung Ihrer Strukturen",
  },
  salesAgent: {
    overview: "Vertriebsagenten-Übersicht",
    userIdMissing: "Vertriebsagenten-Benutzer-ID nicht gefunden",
    loading: "Dashboard wird geladen...",
    errorLoad: "Fehler beim Laden des Dashboards",
    greeting: "Ihre Provisionen und zugewiesenen Aktivitäten & Strukturen",
    walletBalance: "Wallet-Saldo",
    amountOwed: "Ausstehender Betrag",
    lifetimeCredits: "Gesamtgutschriften (Provisionen)",
    assignedScopes: "Zugewiesene Bereiche",
    walletDesc: "Provisionen und Auszahlungen prüfen",
    assignments: "Zuweisungen",
    assignmentsDesc:
      "Aktivitäten und Strukturen anzeigen, auf denen Sie verdienen",
    support: "Support",
    supportDesc: "Hilfe erhalten oder Ticket eröffnen",
  },
  customer: {
    welcomeTitle: "Willkommen zurück!",
    welcomeDesc: "Verfolgen Sie Ihre Restaurantbelege und Treuepunkte",
    myBookings: "Meine Buchungen",
    myBookingsDesc: "Beleg-Uploads anzeigen und verwalten",
    pointsBalance: "Punktestand",
    pointsCount: "{{count}} Punkte",
  },
} as const;
